import React, { useEffect, useState } from "react";
import {
  Dialog,
  Paper,
  Box,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import usePublicLocale from "../i18n/usePublicLocale";
import axios from "../api";

export default function PrivacyModal({ open, onClose }) {
  const [ctrlName, setCtrlName] = useState("Recin p.s.a.");
  const [ctrlAddress, setCtrlAddress] = useState(
    "ul. Tomasza Zana 43 lok. 2.1, Lublin, 20-601, Poland",
  );
  const [contact, setContact] = useState("r.szykowski@ilcoud.com");
  const [loading, setLoading] = useState(false);
  usePublicLocale(["privacy", "landing"]);
  const { t } = useTranslation("privacy");

  useEffect(() => {
    let mounted = true;
    async function fetchSettings() {
      setLoading(true);
      try {
        const r = await axios.get("/public/settings", {
          skipErrorRedirect: true,
        });
        if (!mounted) return;
        if (r.data) {
          if (r.data.company_name) setCtrlName(r.data.company_name);
          if (r.data.contact_email) setContact(r.data.contact_email);
          const addrParts = [];
          if (r.data.company_address_line1)
            addrParts.push(r.data.company_address_line1);
          if (r.data.company_postcode || r.data.company_city)
            addrParts.push(
              `${r.data.company_postcode || ""} ${r.data.company_city || ""}`.trim(),
            );
          if (r.data.company_country) addrParts.push(r.data.company_country);
          if (addrParts.length) setCtrlAddress(addrParts.join(", "));
        }
      } catch (e) {
        /* ignore */
      }
      setLoading(false);
    }
    if (open) fetchSettings();
    return () => {
      mounted = false;
    };
  }, [open]);

  // If modal open is false, don't render heavy content
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { zIndex: 1600 } }}
    >
      <Box sx={{ p: 3 }}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 3,
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Paper sx={{ p: 3 }} elevation={0}>
            <Typography variant="h6" gutterBottom>
              {t("title")}
            </Typography>
            <Typography variant="caption" color="text.secondary" gutterBottom>
              {t("effectiveDate")}
            </Typography>
            {(t("sections", { returnObjects: true }) || []).map((s, i) => {
              // Coerce body to a string; translations can return arrays/objects.
              const bodyRaw = s?.body ?? "";
              let body = Array.isArray(bodyRaw)
                ? bodyRaw.join("\n\n")
                : String(bodyRaw || "");
              // replicate DPO interpolation used in privacy page
              const dpoName = "Błażej Kowalski-Gwardys";
              const dpoContact = "b.kowalski@mediadock.tv";
              if (i === 1) {
                body = t(dpoName && dpoContact ? "dpo.with" : "dpo.without", {
                  dpoName,
                  dpoContact,
                  contact,
                });
              }
              body = body
                .replace("{{ctrlName}}", ctrlName)
                .replace("{{ctrlAddress}}", ctrlAddress)
                .replace("{{contact}}", contact)
                .replace("{{dpoName}}", dpoName)
                .replace("{{dpoContact}}", dpoContact);
              return (
                <Box key={i} sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" gutterBottom>
                    {s.title}
                  </Typography>
                  <Typography variant="body2">{body}</Typography>
                </Box>
              );
            })}
            {(() => {
              const discRaw = t("disclaimer") || "";
              const dpoName = "Błażej Kowalski-Gwardys";
              const dpoContact = "b.kowalski@mediadock.tv";
              const disc = String(discRaw || "")
                .replace("{{ctrlName}}", ctrlName)
                .replace("{{ctrlAddress}}", ctrlAddress)
                .replace("{{contact}}", contact)
                .replace("{{dpoName}}", dpoName)
                .replace("{{dpoContact}}", dpoContact);
              return (
                <Typography variant="caption" color="text.secondary">
                  {disc}
                </Typography>
              );
            })()}
          </Paper>
        )}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button onClick={onClose}>{t("close") || "Close"}</Button>
        </Box>
      </Box>
    </Dialog>
  );
}
